import { useState } from "react"
import { useParams } from "react-router-dom";

// compoonents
import GenerateAccrual from "./GenerateAccrual"
import AccrualsList from "./AccrualsList"
import ErrorDisplay from "../../components/ErrorDisplay"
import Loading from '../../components/Loading';

// hooks
import useGetFetch from "../../hooks/useGetFetch"

// global
import { projectStore } from "../../store/Store"


export default function Accruals() {
  // globals
  const currentProject = projectStore(data => data.currentProject)
  const setCurrentProject = projectStore(data => data.setCurrentProject)
  const setProjectAccruals = projectStore(data => data.setProjectAccruals)
  const setProjectLoads = projectStore(data => data.setProjectLoads)
  const setProjectAssetLoads = projectStore(data => data.setProjectAssetLoads)
  // local
  const [accrualTrigger, setAccrualTrigger] = useState(false)
  const {id} = useParams('id')
  const {isPending: projectAccrualsPending, error} = useGetFetch(`${process.env.REACT_APP_BACKEND}/pc/project-accruals/${id}`, setProjectAccruals)
  const {isPending: loadsPending, error: loadsError} = useGetFetch(`${process.env.REACT_APP_BACKEND}/pc/loads/${id}`, setProjectLoads)
  const {isPending: assetLoadsPending, error: assetLoadsError} = useGetFetch(`${process.env.REACT_APP_BACKEND}/pc/asset-loads/${id}`, setProjectAssetLoads)
  const {isPending: projectPending, error: projectError} = useGetFetch(`${process.env.REACT_APP_BACKEND}/pc/project/${id}`, setCurrentProject)
  if (error || loadsError || projectError || assetLoadsError) {
    return (
     <ErrorDisplay 
        message={"Something went wrong"}
        code={500}
      />
    )
  }
  
  return (!projectAccrualsPending && !loadsPending && !assetLoadsPending && !projectPending) ? (
    <div className="container-fluid">
      <div className='d-flex justify-content-between project-header border-bottom'>
        <h4>Accruals - {currentProject.project.job_name}</h4>
        <button className="btn btn-secondary" onClick={() => setAccrualTrigger(true)}>Generate Accrual</button>
      </div>
      {accrualTrigger && 
        <GenerateAccrual
          setTrigger={setAccrualTrigger}
        />
      }
      <AccrualsList/>
    </div>
    
  ) : (
    <Loading />
  )
}
